import React from "react";
import * as ReportService from "../../../services/report-service";
import { connect } from "react-redux";
import * as ErrorAction from "../../../redux/action/error-action";
import { Pagination } from "react-bootstrap";
import RedirectIfNotLogged from "../../menu/redirect-if-not-logged";
import Header from "../../header";
import ReportsAddArticleDialog from "./reports-add-article-dialog";
import {
  CircularProgress,
  DropDownMenu,
  FlatButton,
  MenuItem,
  RaisedButton,
  TextField
} from "material-ui";
import ArticlesTable from "../../reports/reports-articles-table";
import ReportsArticleDetailsDialog from "../../reports/reports-article-details-dialog";
import PurchaseRequisitionEditModal from "../paper/paper-edit-modal";
import { Constants } from "../../../constants";
import request from "../../../config/axios-config";
import * as fileSaver from "file-saver";
import * as validator from "../../../general/validators/validator";

const FILTER_ALL = 0;
const FILTER_NEW_ARTICLES = 1;
const SEARCH_BY_CPV_CODE = 2;
const DEFAULT_SELECTED_MONTHS = "1-12";

class ReportsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      activePage: 1,
      totalPages: 0,
      emptyData: false,
      lastPage: true,
      wasDataLoaded: false,
      data: [],
      filterValue: FILTER_NEW_ARTICLES,
      searchCpvValue: "",
      searchWords: "",
      showDetails: false,
      showDetailsData: null,
      showPaper: false,
      showPaperData: null,
      downloadingReport: false,
      showWarning: false,
      excelSelectedYear: new Date().getFullYear(),
      createdYear: new Date().getFullYear(),
      excelSelectedMonthInterval: DEFAULT_SELECTED_MONTHS,
      error: {},
      shouldSearchByCpv: false,

      //ADD DIALOG
      showAddDialog: false
    };
  }

  componentDidMount() {
    if (this.props.user.canSeeAllReports) {
      this.setState(
        {
          filterValue: FILTER_ALL
        },
        () => {
          this.refreshData(0);
        }
      );
    } else {
      this.refreshData(0);
    }
  }

  componentWillUnmount() {
    this.props.hideError();
  }

  onExcelDownloadClick = () => {
    let months = this.state.excelSelectedMonthInterval;
    if (validator.isEmpty(months)) {
      months = DEFAULT_SELECTED_MONTHS;
      this.setState({
        excelSelectedMonthInterval: DEFAULT_SELECTED_MONTHS
      });
    }

    if (!validator.isValidBetweenMonths(months)) {
      this.setState({
        error: { months: "Format gresit!" }
      });
      return;
    }

    let url =
      Constants.SERVER_ENDPOINT +
      "/document/excel/" +
      "?year=" +
      this.state.excelSelectedYear +
      "&months=" +
      months;
    this.setState({
      showWarning: false,
      downloadingReport: true,
      error: {}
    });
    this.props.hideError();
    request({
      url: url,
      method: "GET",
      responseType: "blob"
    })
      .then(response => {
        console.log("HEADERS", response.headers);
        const suggestedFileName = response.headers.filename;
        const effectiveFileName =
          suggestedFileName === undefined
            ? "Achizitii raport.xlsx"
            : suggestedFileName;
        fileSaver.saveAs(response.data, effectiveFileName);

        this.setState({
          showWarning: !validator.isEmpty(response.headers.warning),
          downloadingReport: false
        });

        setTimeout(() => {
          this.setState({
            showWarning: false
          });
        }, 4000);
      })
      .catch(response => {
        this.setState({
          downloadingReport: false
        });
        this.props.showError(
          "Descarcarea documentului a esuat! Va rog reincercati!"
        );
      });
  };

  refreshData = page => {
    this.props.hideError();
    this.setState({ loadingData: true });

    let query = this.getFilterQuery();

    if (page === undefined || page === null) {
      page = 0;
    }

    let createdYear = this.state.createdYear;
    if (createdYear === undefined || createdYear === null) {
      createdYear = new Date().getFullYear();
    }

    ReportService.getAllArticlesFromApprovedPapers(createdYear, page, query)
      .then(response => {
        let isEmptyData =
          !response.data.content || response.data.content.length === 0;
        this.setState({
          data: response.data.content,
          lastPage: response.data.last,
          loadingData: false,
          emptyData: isEmptyData,
          totalPages: response.data.totalPages
        });
      })
      .catch(err => {
        this.setState({
          loadingData: false
        });
        this.props.showError("A aparut o eroare! Va rog reincercati!");
      });
  };

  onFilterChanged = (event, index, value) => {
    if (value === SEARCH_BY_CPV_CODE) {
      this.setState({
        filterValue: value,
        shouldSearchByCpv: true,
        page: 0
      });
    } else {
      this.setState(
        {
          filterValue: value,
          searchWords: "",
          page: 0,
          shouldSearchByCpv: false,
          searchCpvValue: ""
        },
        () => {
          this.props.history.push("/app/reports/0");
          this.refreshData(0);
        }
      );
    }
  };

  getFilterQuery = () => {
    let filterQuery = "?filter=";
    let searchQuery = "?search=";
    let filter = this.state.filterValue;

    if (filter === FILTER_ALL) {
      return filterQuery + "all";
    } else if (filter === FILTER_NEW_ARTICLES) {
      return filterQuery + "new";
    } else if (filter === SEARCH_BY_CPV_CODE) {
      return searchQuery + this.state.searchCpvValue;
    }

    return filterQuery + "all";
  };

  handlePageChanged = newPage => {
    const newPageInt = parseInt(newPage) - 1;
    this.setState(
      {
        page: newPageInt
      },
      () => {
        this.refreshData(newPageInt);
      }
    );
    this.props.history.push("/app/reports/" + newPageInt);
  };

  onSeePaperClicked = el => {
    this.setState({
      showPaperData: el.paper,
      showPaper: true
    });
    this.props.onDialogVisible(true);
  };

  onPaperDialogClose = () => {
    this.setState({
      showPaperData: null,
      showPaper: false
    });
    this.props.onDialogVisible(false);
  };

  onEditClicked = el => {
    this.setState({ showDetailsData: el, showDetails: true });
    this.props.onDialogVisible(true);
  };

  onEditClose = () => {
    this.setState({
      showDetailsData: null,
      showDetails: false
    });
    this.props.onDialogVisible(false);
  };

  onDeleteClicked = article => {
    console.log("clicked", article.id);
    ReportService.deleteArticle(article.id)
      .then(response => {
        let index = this.state.data.indexOf(article);
        if (index !== -1) {
          let copy = [...this.state.data];
          copy.splice(index, 1);
          this.setState({
            data: copy
          });
        }
        console.log("removed");
      })
      .catch(err => {
        this.props.showError("Stergerea a esuat! Va rog reincercati!");
      });
  };

  render() {
    const filterDiv = (
      <div style={{ display: "inline-block", verticalAlign: "middle" }}>
        <DropDownMenu
          value={this.state.filterValue}
          onChange={this.onFilterChanged}
        >
          <MenuItem value={FILTER_ALL} primaryText="Arata toate articolele" />
          {(this.props.user.canEditAcquisitionsReports ||
            this.props.user.canEditAccountingReports ||
            this.props.user.canEditReceptionReports) && (
            <MenuItem
              value={FILTER_NEW_ARTICLES}
              primaryText="Arata articolele nefinalizate"
            />
          )}
          <MenuItem
            value={SEARCH_BY_CPV_CODE}
            primaryText="Cauta dupa cod CPV"
          />
        </DropDownMenu>
      </div>
    );

    const paginationButtons = (
      <div
        style={{
          display: "inline-block",
          verticalAlign: "middle",
          marginLeft: "10px",
          marginTop: "-10px"
        }}
      >
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={10}
          items={this.state.totalPages}
          activePage={this.state.page + 1}
          onSelect={this.handlePageChanged}
        />
      </div>
    );

    let reportsArticleDetailsDialogTitle;

    if (this.state.showDetailsData && this.state.showDetailsData.paper) {
      reportsArticleDetailsDialogTitle =
        "Detalii articol: " +
        this.state.showDetailsData.paper.yearId +
        "/" +
        this.state.showDetailsData.paper.createdYear +
        "/" +
        this.state.showDetailsData.orderId;
    } else {
      reportsArticleDetailsDialogTitle = "Articol fara referat";
    }

    return (
      <div>
        <RedirectIfNotLogged />

        {this.state.showAddDialog && (
          <ReportsAddArticleDialog
            onCancel={shouldRefresh => {
              this.setState({
                showAddDialog: false
              });
              this.props.onDialogVisible(false);
              if (shouldRefresh) {
                this.refreshData(this.state.page);
              }
            }}
          />
        )}

        {this.state.showPaper && this.state.showPaperData ? (
          <PurchaseRequisitionEditModal
            title={
              "Referat: " +
              this.state.showPaperData.yearId +
              "/" +
              this.state.showPaperData.createdYear
            }
            onCancel={this.onPaperDialogClose}
            data={this.state.showPaperData}
            canEditPapers={false}
            canSetArticolBugetar={false}
            canDownload={false}
            downloadingDoc={false}
          />
        ) : (
          ""
        )}

        {this.state.showDetails && (
          <ReportsArticleDetailsDialog
            title={reportsArticleDetailsDialogTitle}
            article={this.state.showDetailsData}
            afterReportDetailsSaved={this.props.afterReportDetailsSaved}
            onSeePaperClicked={this.onSeePaperClicked}
            onCancel={this.onEditClose}
          />
        )}

        <div>
          <Header
            title={this.props.title}
            style={{ display: "inline-block" }}
          />
          {!this.state.loadingData &&
            this.state.totalPages > 0 &&
            paginationButtons}

          {this.props.user.canEditAcquisitionsReports && (
            <RaisedButton
              primary
              label={"Adauga"}
              style={{
                marginRight: "20px",
                float: "right",
                verticalAlign: "middle",
                marginTop: "25px"
              }}
              onClick={() => {
                this.setState({
                  showAddDialog: true
                });
                this.props.onDialogVisible(true);
              }}
            />
          )}
        </div>

        {
          <div>
            {filterDiv}
            {(this.props.user.canEditAcquisitionsReports ||
              this.props.user.canEditAccountingReports ||
              this.props.user.canEditReceptionReports) && (
              <TextField
                style={{
                  width: "70px",
                  display: "inline-block",
                  verticalAlign: "middle"
                }}
                floatingLabelText="Din anul"
                value={this.state.createdYear}
                onChange={e =>
                  this.setState({
                    createdYear: e.target.value
                  })
                }
              />
            )}

            {this.state.shouldSearchByCpv && (
              <TextField
                style={{
                  width: "70px",
                  display: "inline-block",
                  verticalAlign: "middle",
                  marginLeft: "5px"
                }}
                floatingLabelText="Cod CPV"
                value={this.state.searchCpvValue}
                onChange={e =>
                  this.setState({
                    searchCpvValue: e.target.value
                  })
                }
              />
            )}

            {this.state.shouldSearchByCpv && (
              <FlatButton
                style={{
                  marginRight: "20px",
                  display: "inline-block",
                  verticalAlign: "middle"
                }}
                primary
                label={"CAUTA"}
                onClick={() => {
                  if (!validator.isEmpty(this.state.searchCpvValue)) {
                    this.refreshData(0);
                  }
                }}
              />
            )}

            <div
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                float: "right"
              }}
            >
              {this.state.showWarning && (
                <strong
                  style={{ width: 100, color: "#E1E100", marginRight: "10px" }}
                >
                  Atentie! Unele articole au informatii lipsa!
                </strong>
              )}
              {this.state.downloadingReport && (
                <CircularProgress
                  size={20}
                  style={{
                    marginTop: "10px",
                    marginRight: "10px",
                    display: "inline-block",
                    verticalAlign: "middle"
                  }}
                />
              )}

              <FlatButton
                style={{
                  marginRight: "20px",
                  display: "inline-block",
                  verticalAlign: "middle"
                }}
                primary
                label={"Descarca raportul"}
                onClick={() => this.onExcelDownloadClick()}
              />

              <TextField
                style={{
                  width: "90px",
                  display: "inline-block",
                  verticalAlign: "middle"
                }}
                floatingLabelText="Pentru anul"
                value={this.state.excelSelectedYear}
                onChange={e =>
                  this.setState({
                    excelSelectedYear: e.target.value
                  })
                }
              />

              <TextField
                style={{
                  width: "60px",
                  display: "inline-block",
                  verticalAlign: "middle"
                }}
                floatingLabelText="Lunile"
                errorText={this.state.error.months}
                value={this.state.excelSelectedMonthInterval}
                onChange={e =>
                  this.setState({
                    excelSelectedMonthInterval: e.target.value
                  })
                }
              />
            </div>
            {this.state.emptyData && (
              <div>
                <div style={{ textAlign: "center", marginTop: "50px" }}>
                  <h3>{"Nu exista articole pentru acest criteriu!"}</h3>
                </div>
              </div>
            )}
          </div>
        }
        {<div />}

        {this.state.loadingData ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          !this.state.emptyData && (
            <div>
              <div style={{ display: "inline-block" }}>
                <div>
                  <ArticlesTable
                    user={this.props.user}
                    data={this.state.data}
                    canEdit={true}
                    onEditClicked={this.onEditClicked}
                    onSeePaperClicked={this.onSeePaperClicked}
                    onDeleteClicked={this.onDeleteClicked}
                    onFileDownloadClick={this.onFileDownloadClick}
                  />
                  {this.state.totalPages > 0 && paginationButtons}
                </div>
              </div>
            </div>
          )
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.login.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showError: text => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportsPage);
